import { render } from "./TaskReviewDatePicker.vue?vue&type=template&id=a4648cd2"
import script from "./TaskReviewDatePicker.vue?vue&type=script&lang=js"
export * from "./TaskReviewDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__